import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../../reducers';
import { ForgotPasswordAction, ForgotPasswordResetFormAction } from '../auth.actions';
import { Observable } from 'rxjs';
import { selectForgotPasswordMailSentStatus, forgotPasswordMailSentResponse } from '../auth.selectors';

@Component({
  standalone: false,
  selector: 'dsp-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPasswordComponent implements OnInit {

  public form: FormGroup;
  public forgotPasswordMailSentStatus$: Observable<boolean>;
  public forgotPasswordMailSentResponse$: Observable<string> = new Observable<any>(null);
  public forgotPasswordMailSentStatus = false;



  constructor(
    private readonly router: Router,
    private readonly store: Store<AppState>

  ) {
    this.forgotPasswordMailSentStatus$ = this.selectForgotPasswordMailSentStatus();
    this.forgotPasswordMailSentResponse$ = this.forgotPasswordMailSentResponse();
    this.forgotPasswordMailSentStatus$.subscribe(status => {
      this.forgotPasswordMailSentStatus = status;
    });
  }

  ngOnInit() {
    this.form = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email])
    });
  }

  public continue(): void {
    if (this.form.invalid) {
      return;
    } else {
      if (!this.forgotPasswordMailSentStatus) {
        this.store.dispatch(new ForgotPasswordAction(this.form.value));
      } else {
        this.form.reset();
        this.forgotPasswordMailSentStatus = false;
        this.store.dispatch(new ForgotPasswordResetFormAction());
        this.router.navigate(['/provision/login'], { queryParamsHandling: 'preserve' });
      }
    }
  }

  public reset(): void {
    this.form.reset();
    this.forgotPasswordMailSentStatus = false;
    this.store.dispatch(new ForgotPasswordResetFormAction());
    this.router.navigate(['/provision/login'], { queryParamsHandling: 'preserve' });
  }

  private selectForgotPasswordMailSentStatus(): Observable<boolean> {
    return this.store.pipe(
      select(selectForgotPasswordMailSentStatus)
    );
  }

  private forgotPasswordMailSentResponse(): Observable<string> {
    return this.store.pipe(
      select(forgotPasswordMailSentResponse)
    );
  }
}
